import { useEffect, useState } from 'react';
import api from '../api';

// Fetches the OSRM road route once both points are set. Returns {route, loading, error}.
export function useRoute(pickup, drop) {
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const key = pickup && drop ? `${pickup.lat},${pickup.lng}|${drop.lat},${drop.lng}` : null;

  useEffect(() => {
    if (!key) {
      setRoute(null);
      setError('');
      return undefined;
    }
    const controller = new AbortController();
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const { data } = await api.post('/api/geo/route', { pickup, drop }, { signal: controller.signal });
        setRoute(data);
      } catch (err) {
        if (err?.name !== 'CanceledError') {
          setRoute(null);
          setError(err?.response?.data?.detail || 'Could not calculate the route');
        }
      } finally {
        setLoading(false);
      }
    };
    load();
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { route, loading, error };
}
